import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

export enum BiointelligentLinkType {
  RNA_PART = 'RNA_PART',
  DNA_PART = 'DNA_PART',
  AMINO_ACID_PART = 'AMINO_ACID_PART',
  TRANSCRIPTION = 'TRANSCRIPTION',
  TRANSLATION = 'TRANSLATION',
}

export const LINK_TYPE_TO_COMPONENT_NAME: {[linkType in BiointelligentLinkType]: string} = {
  [BiointelligentLinkType.RNA_PART]: 'part',
  [BiointelligentLinkType.DNA_PART]: 'part',
  [BiointelligentLinkType.AMINO_ACID_PART]: 'part',
  [BiointelligentLinkType.TRANSCRIPTION]: 'transcription',
  [BiointelligentLinkType.TRANSLATION]: 'translation',
};

export const LINK_TYPE_TO_LINKED_ITEM_NAME: {[linkType in BiointelligentLinkType]: string} = {
  [BiointelligentLinkType.RNA_PART]: 'RNA sequence',
  [BiointelligentLinkType.DNA_PART]: 'DNA sequence',
  [BiointelligentLinkType.AMINO_ACID_PART]: 'AA sequence',
  [BiointelligentLinkType.TRANSCRIPTION]: 'RNA sequence',
  [BiointelligentLinkType.TRANSLATION]: 'AA sequence',
};

export const LINK_TYPE_TO_ICON_ID: {[linkType in BiointelligentLinkType]: BenchlingIconName} = {
  [BiointelligentLinkType.RNA_PART]: 'rna',
  [BiointelligentLinkType.DNA_PART]: 'dna',
  [BiointelligentLinkType.AMINO_ACID_PART]: 'protein',
  [BiointelligentLinkType.TRANSCRIPTION]: 'rna',
  [BiointelligentLinkType.TRANSLATION]: 'translation',
};
